module.exports = __webpack_public_path__ + "img/wdraw.56bc21d7.png";